import { PageWithTotalCountDTO } from "@js/DTO/PageWithTotalCountDTO.cs.d";
import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import {
  AppPackagePricing,
  ApplicationUser,
  InvitedBrokerDTO,
  Organisation,
  OrganisationLink,
  PlanTypeEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  Invite,
  OrganisationAndBrokerDetailsMessage,
  OrganisationProductAccessMessageResponse,
} from "@src/apis/ModularClient";

export class OrganisationService extends BaseService<Organisation, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  brickflowBrokerOrg: Organisation;

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/organisation";
    this.$broadcastBusinessNameSingular = "organisation";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  protected fetchpageInternal(
    needle: string,
    page: number,
    count: number,
    screen: string,
    message: string,
  ): ng.IPromise<PageWithTotalCountDTO> {
    let defer = this.$q.defer<PageWithTotalCountDTO>();
    this.$http
      .get(this.$baseAddress + "/organisationPage?needle=" + needle + "&page=" + page + "&Count=" + count)
      .then((response) => {
        defer.resolve(response.data as PageWithTotalCountDTO);
      })
      .catch((response) => {
        this.$broadcastservice.broadcastError(screen, message);
        defer.reject(response);
      });
    return defer.promise;
  }
  fetchpage(needle: string, page: number, count: number): ng.IPromise<PageWithTotalCountDTO> {
    return this.fetchpageInternal(
      needle,
      page,
      count,
      this.$broadcastScreen,
      "Unable to get a list of " + this.$broadcastBusinessNamePlural + " from the  Please try again shortly.",
    );
  }

  /**
   * Gets the organisation relevant to the current user
   */
  getOrganisation(): ng.IPromise<Organisation> {
    let defer = this.$q.defer<Organisation>();

    this.$http
      .get(this.$baseAddress + "/getorganisation")
      .then((response) => {
        defer.resolve(response.data as Organisation);
      })
      .catch((response) => {
        defer.reject(response);
      });

    return defer.promise;
  }

  /**
   * Is the Organisation a "paid up" i.e. active, premium organisation
   * @param orgId
   */
  isOrgActivePremium(orgId: number): ng.IPromise<boolean> {
    let defer = this.$q.defer<boolean>();

    this.fetch(orgId).then((response: Organisation) => {
      // TODO JLH Need to implement the paid up part of this function
      var isPaidUpPremium = response.planType == PlanTypeEnum.Premium; /* && isPaidUp*/
      defer.resolve(isPaidUpPremium);
    });

    return defer.promise;
  }

  /**
   * Is the supplied organisation a white labelled organisation
   * @param orgId
   */
  isOrgWhiteLabelled(orgId: number): ng.IPromise<boolean> {
    let defer = this.$q.defer<boolean>();

    this.fetch(orgId).then((response: Organisation) => {
      var isWhiteLabelled = response.hasWhiteLabelAddOnPaid == true && response.isWhiteLabelled == true;
      defer.resolve(isWhiteLabelled);
    });

    return defer.promise;
  }

  getAppName() {
    let lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      return lsd;
    } else {
      return "Brickflow";
    }
  }

  /**
   * @param data
   */
  sendDataToParent(type: string, data: any): void {
    try {
      if (window.self !== window.top) {
        window.parent.postMessage(
          {
            type: type,
            data,
          },
          "*",
        );
      } else {
        console.log("Not running inside an iframe. Cannot send data to parent.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  getData(type: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (window.self !== window.top) {
        const messageHandler = (event) => {
          if (event.data && event.data.type === `${type}Data`) {
            let targetOrigin = event.origin;
            if (!targetOrigin || targetOrigin === "null") {
              targetOrigin = "*";
            }
            (event.source as Window).postMessage(
              {
                type: "acknowledgment",
                data: {
                  message: `${type}Data received and processed`,
                  originalType: `${type}`,
                },
              },
              targetOrigin,
            );
            resolve(event.data.data[type]);
            window.removeEventListener("message", messageHandler);
          }
        };

        // remove existing message event listeners
        window.removeEventListener("message", messageHandler);

        // add new message event listener
        window.addEventListener("message", messageHandler, false);

        // Request data from parent
        window.parent.postMessage(
          {
            type: `request${type}`,
          },
          "*",
        );

        setTimeout(() => reject(`Timed out while waiting for ${type}`), 5000);
      } else {
        resolve("");
      }
    });
  }

  hasValidWhitelabelProperties(organisation) {
    if (
      organisation != null &&
      organisation.organisationCode != null &&
      organisation.organisationCode.length > 0 &&
      organisation.hasWhiteLabelAddOnPaid &&
      organisation.isWhiteLabelled
    ) {
      return true;
    }

    return false;
  }
}
